import React, { Component } from 'react'
import { MuiGrid } from '../../../ui'
import { MuiAddCircle, MuiTypography, MuiButton, MuiDialog, MuiKeyboardArrowDown, MuiKeyboardArrowUp, MuiToolTip } from '../../../ui/MaterialUIComponents'
import { WeeklyCalendarComponent } from '.'
import theme from '../../../../assests'
import { GradePickerComponent, gradePickerUtil } from '../../gradePicker'
import lodashUtil from 'lodash';
import CalendarComponent from '../../Calender/CalenderComponent'
import { toast } from 'react-toastify';

import '../../../ui/scrollbarForLog.css'
import PageHeaderComponent from '../../../ui/PageHeaderComponent'
import { getKeyFromLS, setDataInLS } from '../../../../utils/LocalStorageUtil'
import { StepperUtil } from '../stepper/.';

class CreateCalendarComponent extends Component {
	constructor(props) {
		super(props)

		let localstate = this.props.location.state;
		if (!localstate) {
			localstate = getKeyFromLS(StepperUtil.STEPPER_STATE_KEY_LS);
		} else {
			//this.setLocationStateInLS(localstate);
			setDataInLS(StepperUtil.STEPPER_STATE_KEY_LS, localstate);
		}

		this.state = {
			open: false,
			openForFiltering: false,
			gradeLevelsForCalendar: { gradeLevels: localstate.activeSchool.school_master.gradeLevels },
			showPeriod: false,
			calendarPeriodDetails: this.props.edit === true ?
				this.props.cal.periodsDetails
				:
				this.props.calendar.periodsDetails,
			periodFilterGradeLevel: { gradeLevels: localstate.activeSchool.school_master.gradeLevels, isAllChecked: true },
			isGradeDropDownFlagForCalendar: false,
			isGradeDropDownFlagForFiltering: false,
			schedule_constraints_backup: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])),
			isSavePending: false
		}
	}
	alertMessage = () => {
		alert("some message!!")
	}

	componentWillMount = () => {
		if (this.props.cal.gradeDetails === undefined) { this.handleOpen() }
	}
	handleOpen = () => {
		const i18n = this.props.i18n
		if (this.props.cal.periodsDetails.length === 0) {
			if (this.props.edit == false) {
				if (this.props.gradeDetailsInWeeklyCal != undefined && !lodashUtil.isEmpty(this.props.gradeDetailsInWeeklyCal)) {
					let gradeLevels = gradePickerUtil.constructGradeLevelJSON(this.state.gradeLevelsForCalendar, this.props.gradeDetailsInWeeklyCal)
					this.setState({ gradeLevels: gradeLevels, open: true, openForFiltering: false, showPeriod: true, isGradeDropDownFlagForCalendar: true });
				} else {
					let gradeLevels = gradePickerUtil.constructGradeLevelJSONToBeRendered(this.state.gradeLevelsForCalendar);
					this.setState({ gradeLevelsForCalendar: gradeLevels, open: true, openForFiltering: false, showPeriod: true, isGradeDropDownFlagForCalendar: true });
				}
			}
			else {
				if (this.props.gradeDetailsInWeeklyCal != undefined && !lodashUtil.isEmpty(this.props.gradeDetailsInWeeklyCal)) {
					let gradeLevels = gradePickerUtil.constructGradeLevelJSON(this.state.gradeLevelsForCalendar, this.props.gradeDetailsInWeeklyCal)
					this.setState({ gradeLevels: gradeLevels, open: true, openForFiltering: false, showPeriod: true, isGradeDropDownFlagForCalendar: true });
				} else {
					let gradeLevels = gradePickerUtil.constructGradeLevelJSONToBeRendered(this.state.gradeLevelsForCalendar);
					this.setState({ gradeLevels: gradeLevels, open: true, openForFiltering: false, showPeriod: true, isGradeDropDownFlagForCalendar: true });
				}
			}
		} else {
			toast(i18n.calendar.gradeDetailsNotEditable);
		}
	};

	handleOpenForPeriodFiltering = () => {
		const i18n = this.props.i18n
		let periodsDetails = this.props.edit === true ? this.props.cal.periodsDetails : this.props.calendar.periodsDetails
		let validationFlag = false;
		if (this.props.gradeDetailsInWeeklyCal === undefined) {
			toast(i18n.calendar.selectGradeFirst);
			validationFlag = true;
		} else if (periodsDetails.length === 0) {
			toast(i18n.calendar.periodsToFilter);
			validationFlag = true;
		}
		if (validationFlag === false) {
			let periodFilterGradeDetails = this.props.periodFilterGradeDetails;

			if (periodFilterGradeDetails === undefined) {
				let periodFilterGradeDetailsFromWeeklyCal = this.props.gradeDetailsInWeeklyCal
				if (periodFilterGradeDetailsFromWeeklyCal.allGrades === true) {
					periodFilterGradeDetailsFromWeeklyCal = gradePickerUtil.changingSubsetGradeDetail(periodFilterGradeDetailsFromWeeklyCal, this.props)
				}
				let subSetGradeLevel = gradePickerUtil.showSubsetOfGrades(this.state.gradeLevelsForCalendar, periodFilterGradeDetailsFromWeeklyCal);
				let savedGradeLevel = gradePickerUtil.constructGradeLevelJSON(subSetGradeLevel, {allGrades:false, gradeLevels:[], grades:[]})
				this.setState({ openForFiltering: true, periodFilterGradeLevel: savedGradeLevel, isGradeDropDownFlagForFiltering: true });
			} else {
				let subSetGradeLevel = gradePickerUtil.showSubsetOfGrades(this.state.gradeLevelsForCalendar, this.props.gradeDetailsInWeeklyCal);
				let savedGradeLevel = gradePickerUtil.constructGradeLevelJSON(subSetGradeLevel, periodFilterGradeDetails)
				this.setState({ openForFiltering: true, periodFilterGradeLevel: savedGradeLevel, isGradeDropDownFlagForFiltering: true });
			}
		}
	}

	onClickOfPeriodDetail = () => {
		this.setState({
			showPeriod: true,

		})
	}
	handleClose = () => {
		this.props.toggleGradPicker();
		this.setState({ open: false, isGradeDropDownFlagForCalendar: false })
		window.location.href = '/'
	};

	handleCloseForPeriodFiltering = () => {
		this.props.toggleGradPicker();
		this.setState({ openForFiltering: false, isGradeDropDownFlagForFiltering: false })
		
	};

	saveForCalendar = (gradeDetails) => {
		this.props.gradePickerSaveInCalendar(gradeDetails);
		this.setState({
			open: false,
			isGradeDropDownFlagForCalendar: false

		})
	}

	saveForFilter = (gradeDetails) => {
		this.props.gradePickerSaveForPeriodFiltering(gradeDetails);
		this.setState({
			openForFiltering: false,
			isGradeDropDownFlagForFiltering: false

		})
	}


	componentWillUnmount = () => {
		if (this.state.isSavePending) {
			this.beforeUnload()
		}
	}
	beforeUnload = async () => {
		var flag = window.confirm('Do you want to save bell time changes?');
		if (flag) {
			!this.props.edit ? await this.props.calendarTableSave() : await this.props.saveEditCalendar(this.props.calIndex, this.props.cal)
		}
		else {
			await this.undoChanges()
		}
	}
	undoChanges = () => {
		this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex] = JSON.parse(JSON.stringify(this.state.schedule_constraints_backup))
	}
	calendarTableCancel = () => {
		this.setState({
			isSavePending: false
		}, async () => {
			await this.undoChanges()
			this.props.calendarTableCancel();
		});
	}
	calendarTableSave = () => {
		this.setState({
			isSavePending: false
		}, () => {
			this.props.calendarTableSave();
		});
	}
	saveEditCalendar = () => {
		this.setState({
			isSavePending: false
		}, () => {
			this.props.saveEditCalendar(this.props.calIndex, this.props.cal);
		});
	}
	weeklyCalendarDelete = (cal) => {
		this.setState({
			isSavePending: true
		}, () => {
			this.props.weeklyCalendarDelete(cal);
		});
	}
	weeklyCalCancel = () => {
		this.props.weeklyCalCancel();
	}
	onClickOfSavePeriod = (cal) => {
		this.setState({
			isSavePending: true
		}, () => {
			this.props.onClickOfSavePeriod(cal);
		});
	}
	render() {
		const { i18n } = this.props

		return (
			<MuiGrid container>
				<PageHeaderComponent {...this.props} title={i18n.calendar.title} subTitle={i18n.calendar.subTitle} />
				<MuiGrid container xs={12} justify="space-between" alignItems="center" >
					{this.props.cal.gradeDetails !== undefined && gradePickerUtil.getGradesString(this.props.cal.gradeDetails).length > 0 &&
						<MuiGrid item  >
							<MuiTypography style={theme.typography.h7} >
								{i18n.calendar.gradeForCalendar} {gradePickerUtil.getGradesString(this.props.cal.gradeDetails)}</MuiTypography>
						</MuiGrid>}
					{
						(this.state.isGradeDropDownFlagForCalendar === true || this.state.isGradeDropDownFlagForFiltering) &&

						<GradePickerComponent
							stopSelectionForGroups={this.state.open === true ? true : undefined}
							{...this.props}
							{...this.state}
							subTitle={i18n.calendar.selectGradePickerSubTitleForCalendar}
							open={this.state.open === true ? this.state.open : this.state.openForFiltering}
							onClickOfSaveInGradePicker={this.state.open ? this.saveForCalendar : this.saveForFilter}
							handleClose={this.state.open ? this.handleClose : this.handleCloseForPeriodFiltering}
							gradeLevels={this.state.open ? this.state.gradeLevelsForCalendar : this.state.periodFilterGradeLevel}
						/>
					}
					<MuiGrid item  >
						{this.props.cal.gradeDetails !== undefined && gradePickerUtil.getGradesString(this.props.cal.gradeDetails).length > 0 &&

							<MuiGrid container xs justify="center" alignItems="center" style={{ border: '2px solid ' + theme.palette.grey.main }}>
								{/* <MuiGrid item style={{ padding: "10px 10px" }}>
								<MuiTypography style={theme.typography.h8} >
									{i18n.calendar.gradeForCalendar}
								</MuiTypography>
							</MuiGrid> */}

								{/* CALENDAR GRADE DETAILS */}
								{/* <MuiGrid item style={{ padding: "0px 10px", borderRight: '2px solid ' + theme.palette.grey.main }}

								>

									<MuiToolTip
										placement="bottom"
										title={
											!this.state.isGradeDropDownFlagForFiltering ?
												this.props.edit === true ?
													this.props.cal.periodsDetails.length !== 0 ?
														"This cannot be edited"
														:
														"Please click to add grade details"
													:
													this.props.calendar.periodsDetails.length !== 0 ?
														"This cannot be edited"
														:
														"Please click to add grade details" : ""
										}
									>
										<MuiGrid container justify="center" alignItems="center"
											//onClick={() => this.handleOpen()}
											style={{
												padding: "2px 10px", cursor: "pointer",
												backgroundColor:

													this.props.edit === true ?
														this.props.cal.periodsDetails.length !== 0 ? theme.palette.grey.lighter : null
														:
														this.props.calendar.periodsDetails.length !== 0 ? theme.palette.grey.lighter : null
											}}
										>

											<MuiGrid item onClick={() => this.handleOpen()}>
												{

													this.props.cal.gradeDetails !== undefined ?
														<MuiTypography style={theme.typography.h8} >{gradePickerUtil.getGradesString(this.props.cal.gradeDetails)}</MuiTypography>
														:
														<MuiTypography style={theme.typography.h8} >Please Select grades</MuiTypography>
												}
											</MuiGrid>
											<MuiGrid item style={{ cursor: "pointer" }}
												onClick={
													this.state.calendarPeriodDetails.length === 0 ?
														() => this.props.toggleGradPickerWithACheck()
														:
														null
												}

											>
												{
													this.state.isGradeDropDownFlagForCalendar === true ?

														<MuiGrid item style={{ cursor: "pointer" }} onClick={() => { this.handleClose() }}>
															<MuiKeyboardArrowUp style={{ color: theme.textColor }} />
														</MuiGrid>
														:
														<MuiGrid item style={{ cursor: "pointer" }}
															onClick={() => this.handleOpen()}
														>
															<MuiKeyboardArrowDown style={{ color: theme.textColor }} />
														</MuiGrid>

												}

											</MuiGrid>

										</MuiGrid>
									</MuiToolTip>
								</MuiGrid> */}


								{/* FILTERING */}

								<MuiGrid item style={{ padding: "10px 10px" }}>
									<MuiTypography style={theme.typography.h8} >
										{i18n.calendar.filterPeriodsInCalendar}
									</MuiTypography>
								</MuiGrid>
								<MuiGrid item
									style={{ padding: "0px 10px" }}
								>
									<MuiGrid container justify="center" alignItems="center"

										onClick={() => this.handleOpenForPeriodFiltering()}
										style={{
											padding: "2px 10px", cursor: "pointer",
											backgroundColor:

												this.props.edit === true ?
													this.props.cal.periodsDetails.length !== 0 ? theme.palette.grey.lighter : null
													:
													this.props.calendar.periodsDetails.length !== 0 ? theme.palette.grey.lighter : null
										}}
									>
										<MuiGrid item  >
											{
												this.props.periodFilterGradeDetails !== undefined ?
													<MuiTypography style={theme.typography.h8} >{gradePickerUtil.getGradesString(this.props.periodFilterGradeDetails)}</MuiTypography>
													:
													<MuiTypography style={theme.typography.h8} >{i18n.gradeDisplayString.noGradeIsSelected}</MuiTypography>}
										</MuiGrid>
										<MuiGrid item style={{ cursor: "pointer" }} onClick={() => this.props.toggleGradPickerForPeriodFiltering()}>
											{
												this.state.isGradeDropDownFlagForFiltering === true ?

													<MuiGrid item style={{ cursor: "pointer" }} onClick={() => { this.handleCloseForPeriodFiltering() }}>
														<MuiKeyboardArrowUp style={{ color: theme.textColor }} />
													</MuiGrid>
													:
													<MuiGrid item style={{ cursor: "pointer" }}>
														<MuiKeyboardArrowDown style={{ color: theme.textColor }} />
													</MuiGrid>
											}

										</MuiGrid>
									</MuiGrid></MuiGrid>
							</MuiGrid>}

					</MuiGrid>
					{/* create */}
					<MuiGrid >

						<MuiButton
							disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
							id='addButton' onClick={this.props.cal.gradeDetails !== undefined && gradePickerUtil.getGradesString(this.props.cal.gradeDetails).length > 0 ? this.props.onClickOfCreate : this.handleOpen}>
							<MuiAddCircle style={{ color: this.props.disableEdit ? "#FFD07D" : theme.palette.orange, paddingRight: 6 }} />
							{i18n.calendar.addPeriod}
						</MuiButton>

					</MuiGrid>

				</MuiGrid>
				{/* DIALOG NEW PERIOD */}
				<MuiDialog
					open={this.props.showCalendarTable}
					fullWidth={true}
					maxWidth={'md'}
				>
					<WeeklyCalendarComponent
						{...this.props}
						{...this.state}
						handleOpen={this.handleOpen}
						handleClose={this.handleClose}
						weeklyCalendarDelete={this.weeklyCalendarDelete}
						weeklyCalCancel={this.weeklyCalCancel}
						onClickOfSavePeriod={this.onClickOfSavePeriod}
					/>
				</MuiDialog>


				{/* TABLE */}
				<MuiGrid style={{ width: "100%", marginTop: " 20px " }} >

					<CalendarComponent
						{...this.props}
						{...this.state}
						handleOpen={this.handleOpen}
						onClickOfPeriodDetail={this.onClickOfPeriodDetail}
						alertMessage={this.alertMessage}
					/>

				</MuiGrid>

				{/* SAVE and CANCEL */}
				<MuiGrid container justify="flex-end" spacing={1} style={{ paddingTop: " 8px " }}>
					<MuiGrid item >
						<MuiButton style={theme.secondaryButtonStyle} onClick={() => this.calendarTableCancel()}>
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>
					{this.props.cal.gradeDetails !== undefined && gradePickerUtil.getGradesString(this.props.cal.gradeDetails).length > 0 ?
						<MuiGrid item >
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={!this.props.edit ? () => this.calendarTableSave() : () => this.saveEditCalendar()}>
								{i18n.commonTexts.save}
							</MuiButton>
						</MuiGrid>

						: null}
				</MuiGrid>
			</MuiGrid >
		)
	}
}

export default CreateCalendarComponent
